import { useContext } from 'react';
import { UserContext } from '@/state/contexts';
import { IUser } from '@/models/auth';

/**
 * Returns the authenticated user and setUser from UserContext.
 * Throws if called outside the authenticated layout (where user is guaranteed).
 *
 * Use this in any component rendered within the Layout route.
 * For login/MFA pages, use useContext(UserContext) directly.
 */
export function useAuthUser(): {
  user: IUser;
  setUser: (user: IUser | null) => void;
} {
  const { user, setUser } = useContext(UserContext);
  if (!user) {
    throw new Error(
      'useAuthUser must be used within an authenticated route. ' +
        'No user found in UserContext.'
    );
  }
  return { user, setUser };
}
